import axios from 'axios'

import { ValuesInterface } from '../Interfaces/Settings/SettingsInterface'
import * as api from './apiHelper'
import { getRequestConfig } from './index'

export async function getSettings() {
  return await api.Get('/settings-service')
}

export async function saveValues(values: ValuesInterface) {
  const response = await axios.put('/settings-service', { values }, getRequestConfig())
  return response.data
}

export async function updateSettings(settings) {
  return await api.Put('/settings-service', settings)
}
